// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IPartialUserItem,
}                               from '../interfaces';

const getAnnotationCommentAuthorItems = async ({
    test,
    parentAnnotationId,
}: {
    test: boolean,
    parentAnnotationId: string,
}): Promise<Map<string, IPartialUserItem>> => {
    const functions = getFunctions();
    const handleGetAnnotationCommentAuthorItems = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        {
            [k: string]: IPartialUserItem,
        }
    >(
        functions,
        'getAnnotationCommentAuthorItems',
    );
    return handleGetAnnotationCommentAuthorItems({
        test,
        parentAnnotationId,
    }).then((result) => {
        const authors: Map<string, IPartialUserItem> = new Map(Object.entries(result.data));
        return authors;
    }).catch((err) => {
        throw err;
    });
};

export default getAnnotationCommentAuthorItems;
